<template>
  <VisionTwoFilters :loading="loading" @filter="onFilter" />
  <div ref="chart" />
</template>

<script>
import VisionTwoFilters from './VisionTwoFilters.vue';
import { getVisionTwoCharts } from '../visionTwoService';
import chart from '@/modules/shared/chartMixin';

export default {
  components: { VisionTwoFilters },
  mixins: [chart],
  methods: {
    async getCharts(filters) { return await getVisionTwoCharts(filters); },
  },
};
</script>
